import { useContext } from "react";
import { useKeycloak } from "../../../auth";
import { getTokenFromStorage } from "../../config/storageConfig";
import { AppConfig } from "../../context/context";
import ManageUsers from "@kdda/user-management-fragment";

// need to pass getTokenFromStorage to user fragment
const UsersPage = () => {
  const appContext = useContext(AppConfig);

  if (!appContext) {
    // Handle the case where AppConfig is not provided
    return <div>AppConfig not provided</div>; // Or some other fallback UI
  }

  const { config, userProfile, setUserProfile } = appContext;

  if (!config) {
    // Handle the case where config is not available in AppConfig
    return <div>Config not available</div>; // Or some other fallback UI
  }

  return (
    <ManageUsers
      config={config}
      profile={userProfile}
      setUserProfile={setUserProfile}
      getTokenFromStorage={getTokenFromStorage}
      getKeycloak={useKeycloak}
    />
  );
};

export default UsersPage;
